import { Link } from "react-router-dom";

export const SectionHeader = ({ eyebrow, title, subtitle, center = true, light = false }) => {
    return (
        <div className={`mb-10 md:mb-14 ${center ? "text-center mx-auto" : ""} max-w-3xl`}>
            {eyebrow && (
                <div className="inline-block text-xs md:text-sm font-semibold tracking-widest uppercase text-[#14B8A6] mb-3">
                    {eyebrow}
                </div>
            )}
            <h2 className={`text-[30px] md:text-[40px] lg:text-[48px] font-bold leading-tight tracking-tight ${light ? "text-white" : "text-[#0B1220]"}`}>
                {title}
            </h2>
            {subtitle && (
                <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? "text-[#AAB6C5]" : "text-[#0B1220]/70"}`}>
                    {subtitle}
                </p>
            )}
        </div>
    );
};

export const PrimaryButton = ({ to, href, children, onClick, testid, type = "button" }) => {
    const cls =
        "inline-flex items-center justify-center gap-2 px-6 md:px-7 py-3 md:py-3.5 rounded-[12px] bg-[#14B8A6] hover:bg-[#0EA5A5] text-white text-sm md:text-base font-semibold transition-all duration-200 hover:-translate-y-0.5 shadow-[0_10px_24px_-8px_rgba(20,184,166,0.55)]";
    if (to) return <Link to={to} className={cls} data-testid={testid}>{children}</Link>;
    if (href) return <a href={href} className={cls} data-testid={testid}>{children}</a>;
    return <button type={type} onClick={onClick} className={cls} data-testid={testid}>{children}</button>;
};

export const SecondaryButton = ({ to, href, children, onClick, testid, light = false }) => {
    const cls = `inline-flex items-center justify-center gap-2 px-6 md:px-7 py-3 md:py-3.5 rounded-[12px] border text-sm md:text-base font-semibold transition-all duration-200 hover:-translate-y-0.5 ${
        light
            ? "border-white/20 text-white hover:bg-white/10"
            : "border-[#0B1220]/15 text-[#0B1220] hover:border-[#14B8A6] hover:text-[#14B8A6]"
    }`;
    if (to) return <Link to={to} className={cls} data-testid={testid}>{children}</Link>;
    if (href) return <a href={href} className={cls} data-testid={testid}>{children}</a>;
    return <button onClick={onClick} className={cls} data-testid={testid}>{children}</button>;
};

export const Section = ({ children, variant = "light", id, className = "" }) => {
    const bg = {
        light: "bg-white text-[#0B1220]",
        gray: "bg-[#F6F8FA] text-[#0B1220]",
        dark: "bg-[#06111F] text-white",
    }[variant];
    return (
        <section id={id} className={`${bg} py-16 md:py-24 lg:py-28 ${className}`}>
            <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">{children}</div>
        </section>
    );
};
